import axios from 'axios';
import keycloak from '../keycloak-config';
import PersistentStorage from '../services/storage';

export const API_URL = import.meta.env.VITE_APP_API_URL;

const axiosClient = axios.create({
    baseURL: API_URL,
    withCredentials: true
});

axiosClient.interceptors.request.use(
    config => {
        if (keycloak.authenticated && keycloak.token) {
            config.headers.Authorization = `Bearer ${keycloak.token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

axiosClient.interceptors.response.use(
    response => response,
    error => {
        if (error.code === 'ERR_NETWORK') {
            error.response.data = JSON.parse({ error: error?.message || 'Network Error' });
        }
        if (error.response && error.response.status === 401) {
            PersistentStorage.setItem('logout', Date.now());
            keycloak.logout();
            error.response.data = JSON.parse('{"error": "Your session has expired."}');
        }
        if (error.response && error.response.status === 403) {
            error.response.data = JSON.parse('{"error": "Sorry. Not enough permissions."}');
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
